import Vue from "vue";
import Verte from 'verte';
import 'verte/dist/verte.css';

Vue.component('ColorPicker', Verte)
